import { FormBuilder, FormGroup } from '@angular/forms';
import { MetadataField, MetadataFieldDetail } from '../global-metadata.entity';
import { Injectable, inject } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalMetadataFactoryService {
  private fb = inject(FormBuilder);

  createFieldConfGroup(field: MetadataField, isTopLevel = false): FormGroup {
    const detailGroup: FormGroup | null =
      isTopLevel && field.datatype === 'DropDown' ?
        this.createDetailGroup(field.detail) :
        null;

    return this.fb.group({
      name: [field.name],
      label: [field.label],
      secondaryLabel: [field.secondaryLabel ?? ''],
      mandatory: [field.mandatory ?? false],
      datatype: [field.datatype],
      detail: detailGroup,
      subFieldConf: this.fb.array(
        (field.subFieldConf ?? []).map((sf) =>
          this.createFieldConfGroup(sf, false),
        ),
      ),
    });
  }

  createObjectTypeMetadataGroup(obj: {
    label: string
    metadata?: unknown[]
  }): FormGroup {
    return this.fb.group({
      label: [obj.label],
      metadata: this.fb.array(
        ((obj.metadata as Record<string, unknown>[]) || []).map((m) => this.createMetadataGroup(m)),
      ),
    });
  }

  public createDetailGroup(detail?: MetadataFieldDetail | null): FormGroup {
    return this.fb.group({
      apiGetURL: [detail?.apiGetURL || ''],
      key: [detail?.key || ''],
      label: [detail?.label || ''],
      redaLabel: [detail?.redaLabel || ''],
      subLabel: [detail?.subLabel || ''],
      headers: this.fb.array(
        (detail?.headers || []).map((hdr) =>
          this.fb.group({
            name: [hdr.name || ''],
            values: this.fb.array(
              (hdr.values || []).map((v) => this.fb.control(v || '')),
            ),
          }),
        ),
      ),
    });
  }

  createMetadataGroup(meta: unknown): FormGroup {
    const metaObj = meta as {
      id?: string
      name?: string
      description?: string
      fieldConf?: MetadataField[]
      fieldConfig?: MetadataField[]
    };
    const fields = metaObj.fieldConf ?? metaObj.fieldConfig ?? [];

    return this.fb.group({
      id: [metaObj.id],
      name: [metaObj.name],
      description: [metaObj.description],
      fieldConf: this.fb.array(
        fields.map((f: MetadataField) => this.createFieldConfGroup(f)),
      ),
    });
  }

  toKey(label: string): string {
    if (!label) return '';
    return label
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '_')
      .replace(/[^\w_]/g, '');
  }
}
